import { Shield, FileText } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer className="bg-card border-t border-border py-12">
      <div className="container px-4">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div className="col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <img src="/assets/icon-32.png" alt="Email2Contact Logo" className="w-8 h-8" />
              <span className="text-xl font-bold">Email2Contact</span>
            </div>
            <p className="text-muted-foreground mb-4">
              AI-powered Outlook add-in that creates complete contacts from email signatures – local, secure, and built with EU privacy standards.
            </p>
            <div className="flex items-center gap-4 text-sm text-muted-foreground">
              <div className="flex items-center gap-2">
                <Shield className="w-4 h-4" />
                <span>EU Privacy Standards</span>
              </div>
            </div>
          </div>
          
          <div>
            <h4 className="font-bold mb-4">Product</h4>
            <ul className="space-y-2 text-muted-foreground">
              <li><Link to="/pricing" className="hover:text-primary transition-smooth">Pricing</Link></li>
              <li><a href="#features" className="hover:text-primary transition-smooth">Features</a></li>
              <li><a href="#how-it-works" className="hover:text-primary transition-smooth">How It Works</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-bold mb-4">Legal & Support</h4>
            <ul className="space-y-2 text-muted-foreground">
              <li>
                <Link to="/privacy" className="hover:text-primary transition-smooth">
                  Privacy Policy
                </Link>
              </li>
              <li><Link to="/terms" className="hover:text-primary transition-smooth">Terms of Service</Link></li>
              <li><Link to="/refund-policy" className="hover:text-primary transition-smooth">Refund & Cancelation Policy</Link></li>
              <li><Link to="/impressum" className="hover:text-primary transition-smooth">Impressum</Link></li>
              <li><Link to="/support" className="hover:text-primary transition-smooth">Support & FAQ</Link></li>
              <li><Link to="/support#contact" className="hover:text-primary transition-smooth">Contact Us</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="pt-8 border-t border-border text-center text-sm text-muted-foreground">
          <p>&copy; {new Date().getFullYear()} Email2Contact. All rights reserved. A privacy-focused Outlook Add-in built for EU compliance, developed in the EU.</p>
        </div>
      </div>
    </footer>
  );
};
